var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGearSparse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.14 12.94a7.83 7.83 0 0 0-.01-1.88l2.03-1.58a.5.5 0 0 0 .12-.61l-1.92-3.33c-.12-.21-.38-.28-.6-.21l-2.38.96c-.5-.39-1.03-.7-1.62-.94l-.36-2.54a.48.48 0 0 0-.48-.41h-3.84a.47.47 0 0 0-.47.4l-.36 2.55c-.59.24-1.13.57-1.62.94l-2.39-.96a.47.47 0 0 0-.58.21L2.74 8.87a.47.47 0 0 0 .12.61l2.02 1.58a6.03 6.03 0 0 0 0 1.88l-2.04 1.58a.5.5 0 0 0-.12.61l1.92 3.33c.12.21.38.28.6.21l2.38-.96c.5.39 1.03.7 1.62.94l.36 2.54a.5.5 0 0 0 .48.41h3.84c.24 0 .44-.17.47-.4l.36-2.55a7.22 7.22 0 0 0 1.62-.94l2.39.96c.21.09.46 0 .58-.21l1.92-3.33a.47.47 0 0 0-.12-.61l-2-1.58ZM12 15.6A3.61 3.61 0 0 1 8.4 12c0-1.98 1.62-3.6 3.6-3.6s3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGearSparse);
export default ForwardRef;